import { useMutation } from '@apollo/client'
import { EditVaccinationRecord, EditVaccinationRecordVariables } from '../../types'
import { EDIT_VACCINATION_RECORD } from './operations'

export const useEditVaccinationRecord = () =>
  useMutation<EditVaccinationRecord, EditVaccinationRecordVariables>(EDIT_VACCINATION_RECORD)
